import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {ReportGroupMileageLazy} from '@containers/reports/readyReports/reportGroupMileage/ReportGroupMileage.lazy';


const ReportGroupMileagePage = () => {
    return (
        <PageLayout

        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportGroupMileageLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportGroupMileagePage;